import { useEffect } from "react";
import { redirectToSessionTimeoutPage } from "../utils/authRedirect.js";

/**
 * Hard navigation — fixes blank screen when leaving /app/* via client-side routing.
 * Auth context is stored in sessionStorage so the target URL stays clean.
 */
export default function FullPageRedirect({ href, reason, from }) {
  const target =
    href ||
    redirectToSessionTimeoutPage({
      reason,
      from,
    });

  useEffect(() => {
    const url = String(target ?? "").startsWith("http")
      ? target
      : `${window.location.origin}${target.startsWith("/") ? target : `/${target}`}`;
    window.location.replace(url);
  }, [target]);

  return (
    <div className="app-screen-guard app-screen-guard--loading" style={{ minHeight: "50vh" }}>
      <p>Redirecting…</p>
    </div>
  );
}
